var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('Share',{attrs:{"data":_vm.shareData}}),_c('common-title',{attrs:{"data":_vm.CommonTitle0}}),_c('common-text',{attrs:{"data":_vm.CommonText1}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }